<template>
  <div class="student-progress__bar">
    <div class="progress-outer" ref='outer'>
      <div class="progress-inner" :style="innerStyle" ref='inner'></div>
    </div>
  </div>
</template>

<script>  
export default {
  props: { 
    percentage: {
      type: Number 
    },
    completed: {
      type: Number 
    },
    total: {
      type: Number 
    },
    displayed: {
      default: true
    }
  },
  data() {
    return {
      width: null,
    }
  },
  watch: {
    displayed(val) {
      if ( val ) {
        setTimeout(() => {
          this.setWidthAndAnimate()
        }, 500)
      }
    }
  },
  computed: {
    innerWidth() {
      if (this.percentage !== undefined) {
        return this.percentage
      }
      
      return 100 / (this.total / this.completed)
    },
    innerStyle() {
      return {
        width: `${this.innerWidth}px`
      }
    }
  },
  methods: {
    setWidthAndAnimate() {
      TweenLite.to(this.$refs.inner, 0.5, { css: { 
        scaleX: 1
      }})
      this.width = this.$refs.outer.offsetWidth
    }
  },
  mounted() {
    if ( this.displayed ) {
      this.setWidthAndAnimate()
    }
  }
}
</script>
